export default function EyeClosedIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.375 16.406a.75.75 0 0 1-1.024-.281l-1.781-3.113a11.553 11.553 0 0 1-3.383 1.562l.55 3.302a.749.749 0 1 1-1.476.247l-.54-3.242c-1.141.159-2.299.159-3.44 0l-.54 3.242a.75.75 0 1 1-1.482-.247l.554-3.302a11.554 11.554 0 0 1-3.381-1.564l-1.776 3.115a.753.753 0 1 1-1.307-.75l1.875-3.281a14.391 14.391 0 0 1-1.809-1.875.75.75 0 1 1 1.168-.938C5.14 11.207 7.862 13.5 12 13.5s6.86-2.296 8.417-4.219a.75.75 0 1 1 1.166.938 14.385 14.385 0 0 1-1.81 1.875l1.876 3.281a.75.75 0 0 1-.274 1.031Z"
      />
    </svg>
  );
}
